//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import UserDropdown from '~/components/partials/user_dropdown'
import CoinSearch from '~/components/partials/coin_search'
import AppDropdown from '~/components/partials/app_dropdown'
export default {
  name: 'Header',
  components: { UserDropdown, CoinSearch, AppDropdown },
  data () {
    return {
      showDropdown: false,
      showOther: false,
      showSearch: false,
      showWallet: false,
      showAppDropdown: false,
      showCoins: false,
      showTrade: false,
      showHelp: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isGuest: 'auth/isGuest'
    }),
    verification () {
      let retVal = false
      if (this.user && this.user.verifications) {
        Object.values(this.user.verifications).forEach((val) => {
          if (val === 'REJECTED' || val === 'REQUESTED') {
            retVal = val
            return false
          }
        })
      }
      return retVal
    }
  }
}
